<!-- 绑定支付宝 -->
<template>
  <div class="content-box" id="bind-alipay">
    <!-- header start -->
    <van-nav-bar
      :title="typeName == 'add' ? '绑定支付宝' : '修改支付宝'"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <!-- header end -->
    <van-cell-group v-if="model != null">
      <van-field
        v-model.trim="model.RealName"
        label="真实姓名"
        placeholder="输入支付宝姓名"
      />
      <van-field
        v-model.trim="model.AlipayAccount"
        label="支付宝账号"
        placeholder="输入支付宝账号"
      />
    </van-cell-group>
    <van-cell-group v-else>
      <van-field
        v-model.trim="realName"
        label="真实姓名"
        placeholder="输入支付宝姓名"
      />
      <van-field
        v-model.trim="alipayAccount"
        label="支付宝账号"
        placeholder="输入支付宝账号"
      />
    </van-cell-group>
    <div
      class="change-btn"
      @click="bindAlipay()"
      tapmode
      v-if="typeName == 'add'"
    >
      立即绑定
    </div>
    <div
      class="change-btn"
      @click="updateAlipay()"
      tapmode
      v-if="typeName == 'edit'"
    >
      立即修改
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import common from "../../../tools/common";

export default {
  data() {
    return {
      name: "",
      account: "",
      id: 0,
      realName: "",
      alipayAccount: "",
      typeName: this.$route.query.typeName,
      model: this.$route.query.model,
    };
  },
  components: {},
  created() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    bindAlipay() {
      var _this = this;
      var realName = "";
      var alipayAccount = "";
      if (_this.model != null) {
        if (_this.model.RealName == "") {
          _this.$toast("支付宝姓名不能为空！");
          return false;
        }
        if (_this.model.AlipayAccount == "") {
          _this.$toast("支付宝账号不能为空！");
          return false;
        }
        realName = _this.model.RealName;
        alipayAccount = _this.model.AlipayAccount;
      } else {
        if (_this.realName == "") {
          _this.$toast("支付宝姓名不能为空！");
          return false;
        }
        if (_this.alipayAccount == "") {
          _this.$toast("支付宝账号不能为空！");
          return false;
        }
        realName = _this.realName;
        alipayAccount = _this.alipayAccount;
      }
      this.$store
        .dispatch({
          type: "UpdateMemberBankInfo",
          realName: realName,
          alipayAccount: alipayAccount,
        })
        .then((res) => {
          if (res.Result.IsSuccess) {
            Toast(res.Result.Message);
            _this.$router.go(-1);
          } else {
            Toast(res.Result.Message);
          }
        });
    },
    updateAlipay() {
      // console.log(this.model);
      var _this = this;
      if (_this.model.RealName == "") {
        _this.$toast("支付宝姓名不能为空！");
        return false;
      }
      if (_this.model.AlipayAccount == "") {
        _this.$toast("支付宝账号不能为空！");
        return false;
      }
      // console.log(_this.model,"zzzzzzzzzz")
      var _options = {
        type: "UpdateMemberBankInfo",
        ..._this.model
      };

      this.$store.dispatch(_options).then((res) => {
        console.log(res,"UpdateMemberBankInfo");
        common.Response.CallResponse(res, (result) => {
          if (result.IsSuccess) {
            _this.$router.go(-1);
          }
        });
      });
    
    },
  },
};
</script>
<style lang="scss" scoped></style>
